<script setup lang="ts">
import type { SearchHit } from '../interfaces/search'

interface Props {
  loading: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
const model = defineModel<SearchHit>()
</script>

<template>
  <div>
    <div v-if="model" class="text-gray-700 font-light text-xs pt-4">
      {{ $t('glossary.showingResult', model.boxes.length) }}
    </div>
    <div v-if="model" class="max-h-96 overflow-y-auto" v-bind="$attrs">
      <table class="w-full">
        <thead class="font-medium text-xs text-gray-700">
          <tr>
            <th class="text-start pb-1">{{ $t('glossary.box') }}</th>
            <th class="text-start pb-1">{{ $t('glossary.city') }}</th>
            <th class="text-start pb-1">{{ $t('glossary.zipCode') }}</th>
            <th class="text-center pb-1">{{ $t('glossary.hit') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="box in model.boxes" class="overflow-hidden text-sm border-t border-gray-100">
            <td class="max-w-40 py-1.5 truncate">
              {{ box.label }}
            </td>
            <td class="max-w-20 truncate">
              {{ box.address }}
            </td>
            <td class="max-w-20 truncate">
              {{ box.zipCode }}
            </td>
            <td class="max-w-20 truncate text-center">
              <span v-if="box.hitWordAreaType" class="bg-success text-white px-2 p-1">{{ box.hitWordAreaType }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
